import moment from 'moment';
import { cloneDeep } from 'lodash';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { FilterColumnService } from '@shared/services/filter-column/filter-column.service';
import { ByWordPipe } from '../../../shared/filters/by-word/by-word.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { SpanTooltipComponent } from '@shared/components/span-tooltip/span-tooltip.component';
import { FilterBySearchAndOrderComponent } from "../../../shared/components/filter-by-search-and-order/filter-by-search-and-order.component";
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'picker-visibility',
    templateUrl: './picker-visibility.component.html',
    standalone: true,
    imports: [
      NgClass,
      AfTranslateDirective,
      FormsModule,
      AfOrderByPipe,
      AfTranslatePipe,
      ByWordPipe,
      SpanTooltipComponent,
      FilterBySearchAndOrderComponent,
      FieldTypeSwitchComponent,
      InputNumberModule,
      TooltipModule
    ]
})
export class PickerVisibilityComponent implements OnInit {
  pickerVisibility: any = {
    findDropdown: '',
    filteredItems: [],
    tableItems: null,
    filterOrder: ['fieldId', 'key'],
    order: false,
    showAdditionalConfig: false,
    allOperators: [
      { listValueId:'<', text:'<' },
      { listValueId:'<=', text:'<=' },
      { listValueId:'<>', text:'<>' },
      { listValueId:'=', text:'=' },
      { listValueId:'>', text:'>' },
      { listValueId:'>=', text:'>=' }
    ],
    secondOperator: [
      { listValueId: '<', text: '<' },
      { listValueId: '<=', text: '<=' },
      { listValueId: '>', text: '>' },
      { listValueId: '>=', text: '>=' }
    ],
    textOperators: [
      { listValueId:'<>', text:'<>' },
      { listValueId:'=', text:'=' },
    ],
    fieldFilter: {
      name: this.translate.instant('common.field'),
      filterOrder: 'fieldLabel'
    }
  }
  constructor(
    private translate: AfTranslateFactory,
    private filterColumnService: FilterColumnService) { }

  @Input() visibilityItems: any = null;
  @Input() orCondition: boolean = false;
  @Input() selectedItems: any = null;
  @Input() itemConfigured: any;
  @Output() changeVisibility = new EventEmitter;
  @ViewChildren(FieldTypeSwitchComponent) fieldsSwitch: QueryList<FieldTypeSwitchComponent>;

  ngOnInit(){
    this.pickerVisibility.selectedItems = this.selectedItems;
    this.configureListItems();
  }

  configureListItems(){
    let filteredItems: any = cloneDeep(this.visibilityItems);
    filteredItems.forEach((item:any) => {
      if(item.fieldId !== this.itemConfigured?.fieldId){
        delete item.showAdditionalConfig;
        let keyTokens:string = item.key.split('-');
        if (keyTokens[0] === 'f' || keyTokens[0] === 'w' || keyTokens[0] === 'le') {
          item.configurable = true;
        }
        // if(this.pickerVisibility.selectedItems[item.key]){
        //   item.selected = true;
        // }
        // this.pickerVisibility.filteredItems.push(item);
        item.selected = !!this.pickerVisibility.selectedItems[item.key];
        this.pickerVisibility.filteredItems.push({ ...item });
      }
    });
  }

  // keyTokens:
  // 'l': 'listas' y 'booleanos',
  // 'le': 'listas' y 'booleanos' en ponderación global,
  // 'f': 'otros, num, money y text'
  // toggleItem(e: any, item:any) {

  //   let selected: boolean = e.newValue;
  //   item.selected = selected;
  //   this.closeOtherAdditionalConfig(item);

  //   if(item.configurable){
  //     if (selected) {
  //       this.configureOperatorsItem(item);
  //     } else{
  //       delete this.pickerVisibility.selectedItems[item.key];
  //       delete this.pickerVisibility.showAdditionalConfig;
  //       delete item.showAdditionalConfig;
  //       delete item.valueText;
  //       delete item.changeConfig;
  //       item.condition = {};
  //       this.emitModifyVisibilities();
  //     }
  //   } else {
  //     if (selected) {
  //         this.pickerVisibility.selectedItems[item.key] = item.valueText;
  //     } else {
  //       delete this.pickerVisibility.selectedItems[item.key];
  //     }
  //     this.emitModifyVisibilities();
  //   }
  //   this.pickerVisibility.filteredItems = this.pickerVisibility.filteredItems.map(i =>
  //     i.key === item.key ? { ...item } : i
  //   );

  // }
  toggleItem(e: any, item: any) {
  const selected: boolean = e.newValue;
  this.closeOtherAdditionalConfig(item);

  item.selected = selected;

  if (item.configurable) {
    if (selected) {
      this.configureOperatorsItem(item);
    } else {
      delete this.pickerVisibility.selectedItems[item.key];
      delete this.pickerVisibility.showAdditionalConfig;
      delete item.showAdditionalConfig;
      delete item.valueText;
      delete item.changeConfig;
      item.condition = {};
      this.emitModifyVisibilities();
    }
  } else {
    if (selected) {
      this.pickerVisibility.selectedItems[item.key] = item.valueText;
    } else {
      delete this.pickerVisibility.selectedItems[item.key];
    }
    this.emitModifyVisibilities();
  }

  // Forzar cambio de referencia
  this.pickerVisibility.filteredItems = this.pickerVisibility.filteredItems.map((i:any) =>
    i.key === item.key ? { ...item } : i
  );
}


  closeOtherAdditionalConfig(item: any){
    if(this.pickerVisibility.showAdditionalConfig && !item.showAdditionalConfig){
      for (let i = 0; i < this.pickerVisibility.filteredItems.length; i++) {
        let itemVisibility = this.pickerVisibility.filteredItems[i];
        if(itemVisibility.showAdditionalConfig){
          let selectedSwitch: any = this.getSwitch(itemVisibility.key);
          selectedSwitch.changeValue();
          delete itemVisibility.showAdditionalConfig;
          delete itemVisibility.changeConfig;
          itemVisibility.condition = {};
          delete this.pickerVisibility.selectedItems[itemVisibility.key];
          break;
        }
      }
    }
  }

  getSwitch(id:any){
    let selectedSwitch: any = this.fieldsSwitch.find((x:any)=>{
      return x.field.id == id;
    });
    return selectedSwitch;
  }

  configureItem(item: any){
    item.changeConfig = true;
    if(item.dataType === 'text'){
      delete item.condition.value1;
    }
    this.configureOperatorsItem(item);
  }

  configureOperatorsItem(item: any){
    if (!item.condition) {
      item.condition = {};
    }
    this.pickerVisibility.operators = item.dataType === 'text'? this.pickerVisibility.textOperators:this.pickerVisibility.allOperators;
    item.prevCondition = cloneDeep(item.condition);
    item.showAdditionalConfig = true;
    this.pickerVisibility.showAdditionalConfig = true;
  }

  checkEditingItem(item: any) {
    let condition:any = item.condition;
    let errors:any = this.checkConditionErrors(item);
    if(!errors){
      if(item.dataType === 'text'){
        item.valueText = condition.operator1 + ' ' + this.translate.instant('common.empty');
        condition.value1 = "\"\"";
      }else{
        item.valueText = condition.operator1 + this.getValueString(condition.value1);
        if (condition.operator2 && condition.value2) {
          item.valueText += ' ' + this.translate.instant('common.and') + ' ' + condition.operator2 + this.getValueString(condition.value2);
        }
      }
      this.pickerVisibility.selectedItems[item.key] = item.valueText;
      this.closeAdditionalConfig(item);
      this.emitModifyVisibilities();
    }
  }

  checkConditionErrors(item: any){
    let condition:any = item.condition;
    let error: boolean = false;
    if(!condition.operator1){
      error = true;
      condition.operator1Error = true;
    }
    if(item.dataType !== 'text'){
      if(condition.operator1 && !condition.value1){
        error = true;
        condition.value1Error = true;
      }
      if(condition.operator2){
        if(!condition.value2){
          error = true;
          condition.value2Error = true;
        }
      }
    }
    return error;
  }

  cancelAdditionalConfig(item: any){
    this.closeAdditionalConfig(item);
    item.condition = item.prevCondition;
  }

  closeAdditionalConfig(item: any){
    delete item.changeConfig;
    delete item.showAdditionalConfig;
    delete this.pickerVisibility.showAdditionalConfig;
  }

  getValueString(value:any) {
    if (moment.isDate(value)) {
        value = value.toLocaleDateString();
    }
    return value;
  }

  changeOrCondition(orCondition: boolean){
    this.orCondition = orCondition;
    if(this.pickerVisibility.selectItems?.length){
      this.emitModifyVisibilities();
    }
  }

  emitModifyVisibilities(){
    this.changeVisibility.emit({selectedItems: this.pickerVisibility.selectedItems, orCondition: this.orCondition});
  }

  operatorSelected(operator:any, type: any, item:any){
    if(item.condition[type] !== operator.listValueId){
      item.condition[type] = operator.listValueId;
      item.condition[type + 'Error'] = false;
      if(item.condition.operator1 === '=' || item.condition.operator1 === '<>'){
        delete item.condition.operator2;
        delete item.condition.value2;
      }
    }else{
      if(type === 'operator1'){
        delete item.condition.operator1;
        delete item.condition.value1;
        delete item.condition.operator2;
        delete item.condition.value2;
      }else if(type === 'operator2'){
        delete item.condition.value2;
        delete item.condition.operator2;
      }
    }
  }

  operatorConditionValue(type: any, item:any){
    if(item.condition[type]){
      item.condition[type + 'Error'] = false;
    }
  }

  resetFilter(){
    this.pickerVisibility.findDropdown = '';
    this.filterVisibility();
  }

  filterOrder(e: any, type:any=''){
    switch(e.action){
      case 'search':
        this.pickerVisibility[type+'searchFilter'] = e.newValue;
        this.filterVisibility(type);
        break;
      case 'order':
        if(this.pickerVisibility.filterOrder === type){
          this.pickerVisibility.order = !this.pickerVisibility.order;
        }else{
          this.pickerVisibility.filterOrder = type;
          this.pickerVisibility.order = false;
        }
        break;
    }
  }

  filterVisibility(type: any = ''){
    let filterList:any = [];
    let filterText: string = this.pickerVisibility.findDropdown;
    if(type){
      filterText = this.pickerVisibility[type+'searchFilter'];
    }
    filterList = this.filterColumnService.filterByWord(filterText, this.visibilityItems, 'fieldLabel');
    this.pickerVisibility.filteredItems = filterList;
  }
}
